(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["anniv-announcement"] && !Shopify.designMode) return;
  try {
    
class AnnivAnncTimer extends HTMLElement {
  connectedCallback() {
    this._end = new Date(this.getAttribute('data-deadline')).getTime();
    this._d = this.querySelector('[data-annc-d]');
    this._h = this.querySelector('[data-annc-h]');
    this._m = this.querySelector('[data-annc-m]');
    this._s = this.querySelector('[data-annc-s]');
    if (!this._end || isNaN(this._end)) return;
    this._update = this._update.bind(this);
    this._update();
    this._iv = setInterval(this._update, 1000);
  }
  disconnectedCallback() { clearInterval(this._iv); }
  _update() {
    var diff = this._end - Date.now();
    if (diff <= 0) {
      clearInterval(this._iv);
      var ended = this.getAttribute('data-ended');
      var clock = this.querySelector('.av-annc__clock');
      var intro = this.querySelector('.av-annc__intro');
      if (clock) clock.textContent = '';
      if (intro && ended) { intro.textContent = ended; intro.style.display = 'inline'; }
      return;
    }
    var t = Math.floor(diff / 1000);
    var p = function (n) { return String(n).padStart(2, '0'); };
    if (this._d) {
      this._d.textContent = p(Math.floor(t / 86400));
      if (this._h) this._h.textContent = p(Math.floor((t % 86400) / 3600));
    } else if (this._h) {
      this._h.textContent = p(Math.floor(t / 3600));
    }
    if (this._m) this._m.textContent = p(Math.floor((t % 3600) / 60));
    if (this._s) this._s.textContent = p(t % 60);
  }
}
if (!customElements.get('anniv-annc-timer')) customElements.define('anniv-annc-timer', AnnivAnncTimer);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["anniv-hero"] && !Shopify.designMode) return;
  try {
    
class AnnivCopy extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', (e) => {
      const btn = e.target.closest('button');
      if (!btn) return;
      const code = this.getAttribute('data-code') || '';
      try { if (navigator.clipboard) navigator.clipboard.writeText(code); } catch (err) {}
      const label = this.querySelector('[data-copy-label]');
      if (label) {
        const prev = label.textContent;
        label.textContent = '✓ Copied';
        clearTimeout(this._t);
        this._t = setTimeout(() => { label.textContent = prev; }, 1800);
      }
    });
  }
}
if (!customElements.get('anniv-copy')) customElements.define('anniv-copy', AnnivCopy);

// In-page smooth scroll for any campaign link pointing at a section (#collections, #gifting, …)
document.querySelectorAll('[data-anniv] a[href^="#"]').forEach(function (a) {
  a.addEventListener('click', function (e) {
    var id = a.getAttribute('href').slice(1);
    if (!id) return;
    var target = document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });
});

// Countdown timer used by the hero + final CTA
class AnnivCountdown extends HTMLElement {
  connectedCallback() {
    this._end = new Date(this.getAttribute('data-deadline')).getTime();
    this._d = this.querySelector('[data-cd-d]');
    this._h = this.querySelector('[data-cd-h]');
    this._m = this.querySelector('[data-cd-m]');
    this._s = this.querySelector('[data-cd-s]');
    if (!this._end || isNaN(this._end)) return;
    this._update = this._update.bind(this);
    this._update();
    this._iv = setInterval(this._update, 1000);
  }
  disconnectedCallback() { clearInterval(this._iv); }
  _update() {
    var diff = this._end - Date.now();
    if (diff <= 0) { diff = 0; clearInterval(this._iv); this.classList.add('is-ended'); }
    var t = Math.floor(diff / 1000);
    var p = function (n) { return String(n).padStart(2, '0'); };
    if (this._d) this._d.textContent = p(Math.floor(t / 86400));
    if (this._h) this._h.textContent = p(Math.floor((t % 86400) / 3600));
    if (this._m) this._m.textContent = p(Math.floor((t % 3600) / 60));
    if (this._s) this._s.textContent = p(t % 60);
  }
}
if (!customElements.get('anniv-countdown')) customElements.define('anniv-countdown', AnnivCountdown);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["buyback-template"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector(this.getAttribute('href')).scrollIntoView({
        behavior: 'smooth'
      });
    });
  });

  // Animation for cards
  const cards = document.querySelectorAll('.quality-card, .process-card, .terms-card');
  
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1
    });

    cards.forEach(card => observer.observe(card));
  }
});

  } catch(e) { console.error(e); }
})();
})();
